import { gql } from '@apollo/client';

export const NBJMenuLists = gql`
  fragment NBJMenuLists on NBJMenuList {
    internalName
    menuSections {
      name
      sectionName
      itemUrl
      itemIcon
      slug
      sectionLinks {
        itemUrl
        name
        itemIcon
        tooltip
        sectionName
        sectionLinks {
          itemIcon
          name
          itemUrl
        }
      }
    }
    footerCopyright
  }
`;
